






































































































































































































































import { UmbrellaData } from "@/mixins/umbrella";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import Pricing from "@/components/order_form/Pricing.vue";
import Share from "@/components/share/Share.vue";
import ConfigFileService from "@/services/config_file_service";
import { ConfigCreator } from "@/mixins/configurator";
import { APIError, BadRequest } from "@/services/error_service";
import Download from "@/components/download/Download.vue";
import { CustomUmbrella } from "@/models/configurator/custom_umbrella";
import { FabricSwatch } from "@/models/products/fabric";
import { Auth } from "@/mixins/auth";
import { Roles } from "@/models/user/roles";
import EditWarning from "@/components/request_a_quote/EditWarning.vue";
import { ProductLineName } from "@/models/products/collection";
import Configurator from "@/components/designer/Configurator.vue";
import LeadTime from "@/components/order_form/LeadTime.vue";
import { UmbrellaHelpers } from "@/mixins/helpers";
import {
  BaseStore,
  CanopyStore,
  FrameStore,
  LayoutStore,
  ShapeStore,
} from "@/mixins/store";

Component.registerHooks(["beforeRouteEnter"]);
@Component({
  components: {
    Pricing,
    Share,
    Download,
    EditWarning,
    Configurator,
    LeadTime
  }
})
export default class RequestQuote extends mixins(
  UmbrellaData,
  ConfigCreator,
  Auth,
  LayoutStore,
  ShapeStore,
  CanopyStore,
  BaseStore,
  FrameStore,
  UmbrellaHelpers
) {
  @Prop() props!: any;
  protected umbrella: CustomUmbrella | null = null;
  protected ProductLineName = ProductLineName;
  protected configFileService = new ConfigFileService();
  protected shareLink = "";
  protected configShortCode = "";
  protected isDownloading = false;
  protected expiration: Date | null = null;
  protected showShareDialog = false;
  protected showEditDialog = false;
  protected Roles = Roles;
  protected qty = 1;
  protected specs = "";
  protected loader: any = null;

  @Watch("qty")
  protected onQtyChange(): void {
    this.sendFrameMsg();
  }

  protected sendFrameMsg(): void {
    const frame = (this.$refs.machform as HTMLIFrameElement).contentWindow;
    if (frame) {
      // https://stackoverflow.com/questions/42376464/uncaught-domexception-failed-to-execute-postmessage-on-window-an-object-co
      const qty = JSON.parse(JSON.stringify({ qty: this.qty }));
      const link = JSON.parse(JSON.stringify({ link: this.shareLink }));
      const shortCode = JSON.parse(
        JSON.stringify({ shortCode: this.configShortCode })
      );
      const specs = JSON.parse(JSON.stringify({ specs: this.specs }));
      frame.postMessage(
        { ...qty, ...link, ...shortCode, ...specs },
        "https://www.frankfordumbrellas.com"
      );
    }
  }

  async created(): Promise<void> {
    if (!this.props.img1 && this.$route.query.quickship) {
      this.$router.replace("/resubmit?quickship=true");
    } else if (!this.props.img1) {
      this.$router.replace("/resubmit");
    }
    this.umbrella = this.getUmbrellaObject();
    if (!this.umbrella) {
      this.$router.replace("/designer");
    }
    if (!this.shareLink) await this.getShareLink();
    await this.getSpecs();
  }

  protected minusQty(): void {
    if (this.qty > 1) {
      this.qty--;
    }
  }

  protected addQty(): void {
    if (this.qty < 9999) {
      this.qty++;
    }
  }

  get image(): string {
    return this.props.img1;
  }

  protected closeShareModal(): void {
    this.showShareDialog = false;
  }

  public makeTitleCase(handle: string): string {
    const words = handle.split(" ");
    return words
      .map(word => {
        return word[0].toUpperCase() + word.substring(1);
      })
      .join(" ");
  }

  protected closeEditModal(): void {
    this.showEditDialog = false;
  }
  protected editConfig(): void {
    if (this.$route.query.quickship) {
      this.showEditDialog = true;
    } else {
      this.$router.replace("/designer/canopy");
    }
  }

  protected async share(isSpecSheet = false): Promise<void> {
    this.isDownloading = isSpecSheet;
    if (
      this.shareLink !== "" &&
      this.configShortCode !== "" &&
      !this.isDownloading
    ) {
      this.showShareDialog = !isSpecSheet;
      return;
    }
    this.loader = this.$loading.show(
      {},
      { before: this.$createElement("h1", "Generating configuration code...") }
    );
    if (!this.shareLink) await this.getShareLink();
    setTimeout(() => {
      this.loader.hide();
      this.showShareDialog = !isSpecSheet;
    }, 1000);
  }

  protected async getSpecs(): Promise<void> {
    const fabricList = (fabrics: ReadonlyArray<FabricSwatch>): string =>
      fabrics.length > 0
        ? fabrics.map(f => ` ${f.name.display} ${f.mfr_code}`).toString()
        : "N/A";
    const fabricSingle = (f: FabricSwatch | null | undefined): string =>
      f ? `${f.name.display} ${f.mfr_code}` : "N/A";

    let str = "";
    str += `Collection: ${this.collection.display_name}`;
    str += `\n Model:  ${
      this.umbrellaModel
        ? this.getUmbrellaModelDisplayName(this.umbrellaModel.model)
        : "N/A"
    }`;
    str += `\n Base Model:  ${this.baseModel ? this.baseModel.model : "N/A"}${
      this.baseOptions && this.baseOptions.wheels ? " with wheels" : ""
    }`;
    str += `\n Base Finish:  ${
      this.baseFinish && this.baseFinish.handle
        ? `${this.baseFinish.display_name}, (${this.baseFinish.handle})`
        : "N/A"
    }`;
    str += `\n Base Stem:  ${this.baseStem ? this.baseStem : "N/A"}`;
    if (this.baseOptions && this.baseOptions.topCover) {
      str += `\n Base Top Cover:  ${this.baseOptions.topCover.model} - ${this.baseOptions.topCover.finish.display_name} (${this.baseOptions.topCover.finish.handle})`;
    }
    str += `\n Main Canopy:  ${this.mainCanopy ? this.mainCanopy : "N/A"}`;
    str += `\n Main Fabric:  ${fabricList(this.mainFabric)}`;
    str += `\n Underside Fabric:  ${fabricSingle(this.undersideFabric)}`;
    str += `\n Top Vent Fabric:  ${fabricList(this.ventTopFabric)}`;
    str += `\n Middle Vent:  ${this.ventMiddle ? this.ventMiddle : "N/A"}`;
    str += `\n Middle Vent Fabric: ${fabricList(this.ventMiddleFabric)}`;
    str += `\n Valance: ${this.valance ? this.valance : "N/A"}`;
    str += `\n Valance Fabric: ${fabricList(this.valanceFabric)}`;
    str += `\n Binding Fabric:  ${fabricSingle(this.bindingFabric)}`;
    str += `\n Fringe:  ${this.fringe ? this.fringe : "N/A"}`;
    str += `\n Fringe Fabric:  ${fabricList(this.fringeFabric)}`;
    str += `\n Rib:  ${this.rib ? this.rib : "N/A"}`;
    str += `\n Main Trim Fabric:  ${fabricSingle(this.mainTrimFabric)}`;
    str += `\n Main Trim Fabric (Inner):  ${fabricSingle(
      this.mainTrimFabricInner
    )}`;
    str += `\n Vent Trim Fabric:  ${fabricSingle(this.ventTrimFabric)}`;
    str += `\n Finish: ${
      this.finish && this.finish.handle
        ? `${this.finish.display_name} (${this.finish.handle})`
        : "N/A"
    }`;
    str += `\n Finial: ${this.finial ? this.finial : "N/A"}`;
    str += `\n Finial Finish:  ${
      this.finialFinish && this.finialFinish.handle
        ? `${this.finialFinish.display_name} (${this.finialFinish.handle})`
        : "N/A"
    }`;
    str += `\n Bottom Pole:  ${this.bottomPole ? this.bottomPole : "N/A"}`;
    str += `\n Spigot:  ${this.spigot ? this.spigot : "N/A"}`;
    this.specs = str;
  }

  protected async getShareLink(): Promise<void> {
    try {
      const body = await this.transformDataToConfigFile();
      const shareFileBody = {
        ...body,
        image: this.image,
        stock: this.isStockOnly
      };
      const res = await this.configFileService.createShareFile(shareFileBody);
      this.shareLink =
        process.env.VUE_APP_SHARE_LINK + "/view?design=" + res.share_id;
      this.configShortCode = res.short_code ?? res.share_id ?? "";
      this.expiration = (res.expireAt as Date) ?? null;
    } catch (err) {
      if (err instanceof BadRequest && !this.shareLink) {
        APIError.redirect(
          "We are unable to generate a quote request for this umbrella. Please contact Frankford Umbrellas directly at info@frankfordumbrellas.com."
        );
      } else {
        APIError.popup(err.message, err.statusCode);
      }
    }
  }

  protected getFabricNames(fabrics: FabricSwatch[]): string {
    const parts = fabrics.map(s =>
      [s.name?.display, s.mfr_code].filter(Boolean).join(" ")
    );
    return parts.join(", ");
  }
  protected formatTitle(title: string, part: string): string {
    let result = "";
    if (title.indexOf(" ")) {
      if (part == "a") {
        result = title.substr(0, title.indexOf(" "));
      } else {
        result = title.substr(title.indexOf(" ") + 1);
      }
    } else {
      return title;
    }

    return result;
  }
}
